export default __webpack_public_path__ + "assets/8b1bf908f99b27c7e33f544189ecf5d3.png";